var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.48331 13.0416C1.14398 12.7218 0.593825 12.7218 0.254492 13.0416C-0.0848308 13.3614 -0.0848308 13.8798 0.254492 14.1997L4.30846 18.0203C4.98708 18.6599 6.08745 18.6599 6.76607 18.0203L10.8224 14.1973C11.1617 13.8775 11.1617 13.359 10.8224 13.0392C10.4831 12.7195 9.93295 12.7195 9.59364 13.0392L6.40825 16.0414V1.31889C6.40825 0.866627 6.01924 0.5 5.53935 0.5C5.05946 0.5 4.67045 0.866627 4.67045 1.31889V16.0452L1.48331 13.0416Z",
    fill: "#1B224C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.6db4a9110cb4ced9810cd97f6d1d1046.svg";
export { ForwardRef as ReactComponent };